<template>
  <section class="c_cs_image_gallery c_wrapper c_wrapper--950">
    <MediaImage
      v-if="!showSlider"
      :sources="[images[0].image[0].lpImageTextUncropped]"
      :caption="getCaption(images[0])"
      caption-class="c_2022--caption"
    />
    <div v-else class="c_agile_slider_2022">
      <agile class="c_slider--arrow_buttons" :options="optionsMain" @after-change="showCurrentSlide($event)">
        <div v-for="(item, index) in images" :key="index">
          <MediaImage
            class="slide"
            :key="index"
            :sources="[item.image[0].lpImageTextUncropped]"
            :caption="getCaption(item)"
            caption-class="c_2022--caption"
          />
        </div>
      </agile>
      <SlideNumbers :current-slide="currentSlide" :number-of-slides="numberOfSlides" />
    </div>
  </section>
</template>

<script>
import MediaImage from 'Components/image/MediaImage.vue';
import { VueAgile } from 'vue-agile';
import SlideNumbers from 'Components/slider/SlideNumbers.vue';

export default {
  props: {
    images: Array,
  },
  components: {
    MediaImage,
    agile: VueAgile,
    SlideNumbers,
  },
  data() {
    return {
      showSlider: false,
      optionsMain: {
        dots: false,
        navButtons: true,
      },
      numberOfSlides: 0,
      currentSlide: 1,
    };
  },
  created() {
    this.images.length > 1 ? (this.showSlider = true) : (this.showSlider = false);
  },
  methods: {
    showCurrentSlide(e) {
      this.currentSlide = e.currentSlide + 1;
    },
    getCaption(item) {
      return item.image[0].caption && item.image[0].caption !== '' ? item.image[0].caption : item.caption;
    },
  },
  mounted() {
    this.numberOfSlides = this.images.length;
  },
};
</script>

<style lang="scss">
.c_cs_image_gallery {
  $self: &;
  padding-top: px_to_rem(40);
  padding-bottom: px_to_rem(40);
  &.c_wrapper {
    padding-left: px_to_rem(40);
    padding-right: px_to_rem(40);
    @include mq($mq_sm_to_md) {
      padding-left: px_to_rem(100);
      padding-right: px_to_rem(100);
    }
  }
  figcaption {
    display: block;
    margin-top: px_to_rem(15);
  }
  .c_agile_slider_2022 .agile__slide {
    flex-direction: column;
  }
}
</style>
